import { SortingQuestionPinSettings } from '@lessonup/pins-shared';
import { styled } from '@lessonup/ui-components';
import React from 'react';
import { PinBackground } from '../components/PinBackground';

export interface SortingQuestionPinProps {
  pinSettings: SortingQuestionPinSettings;
  isThumb?: boolean;
  children?: React.ReactNode;
}

export const SortingQuestionPin: React.FC<SortingQuestionPinProps> = ({ pinSettings, isThumb, children }) => {
  return (
    <SortingWrapper>
      <PinBackground pinType="SORTING_QUESTION" settings={pinSettings} isThumb={isThumb} />
      {children}
    </SortingWrapper>
  );
};

const SortingWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
`;
